import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'KeyboardArrowLeftOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardArrowLeftOutlined.js
// module id = 4317
// module chunks = 2